import { Outlet, Navigate } from "react-router";
import useGetRole from "@/hooks/useGetRole";

export default function ProtectedRoutes() {
    const { isAdmin } = useGetRole();

    return isAdmin ? <Outlet /> : <Navigate to='/schedule' />;
}
